import AScene from "./AScene.js";
import Phaser from 'phaser';

export default class AImage extends Phaser.GameObjects.Image
{
     /**
     * @param {AScene} scene 
     */
    constructor(scene, x, y, frame, texture = 'UIAssets')
    {
        super(scene, x, y, frame, texture);
        this.scene = scene;
        this.tintData = 0xffffff;
    }

    get tint()
    {
        return this.tintData;
    }

    set tint(value)
    {
        this.tintData = value;
        super.tint = value;
    }

    setSize(width, height)
    {
        // this.width = width;
        // this.height = height;
        this.displayWidth = width;
        this.displayHeight = height;
    }

    setMaxSize(width, height) 
    {
        let scaleBy = (this.width > this.height) ? width / this.width : height / this.height;
        this.setSize(this.width * scaleBy, this.height * scaleBy);
        return this;
     }

     getMaxScale(width, height)
     {
        return (this.width > this.height) ? width / this.width : height / this.height;
     }

     preUpdate(){}
}